<script setup lang="ts">
import { computed } from "vue";

const { withEnd = false, text } = defineProps<{
  /** When true, display text as start…end via truncateWithEnd. When false, only CSS ellipsis applies. */
  withEnd?: boolean;
  /** Text to display. Required. When withEnd is true, string is truncated to show start…end. */
  text: string;
}>();

const TRUNCATE_END_CHARS = 5;
const TRUNCATE_START_CHARS = 12;
const TRUNCATE_THRESHOLD = TRUNCATE_START_CHARS + 3 + TRUNCATE_END_CHARS;
const EMPTY_PLACEHOLDER = "\u00A0—";

function truncateWithEnd(str: string): string {
  if (str.length <= TRUNCATE_THRESHOLD) return str;
  return str.slice(0, TRUNCATE_START_CHARS) + "…" + str.slice(-TRUNCATE_END_CHARS);
}

const displayText = computed(() => {
  const trimmed = text.trim();
  const isEmpty = !trimmed || trimmed === EMPTY_PLACEHOLDER;
  const normalized = isEmpty ? "" : text;
  return withEnd ? truncateWithEnd(normalized) : normalized;
});
</script>

<template>
  <span class="truncatable-span">{{ displayText }}</span>
</template>

<style scoped>
.truncatable-span {
  display: inline-block;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}
</style>
